import boostPools from 'config/constants/boostPools'
import tokens from 'config/constants/tokens'
import { useVvsBoostPool } from 'state/xVvs/hooks'
import { useVvsPerBlock } from 'state/farms/useVvsPerBlock'
import { BIG_ONE } from 'utils/bigNumber'
import { getBalanceAmount } from 'utils/formatBalance'
import usePastWeekApr from './usePastWeekApr'
import useXvvsRate from './useXvvsRate'

// Returns apr in %
export const useVaultsApr = () => {
  const pastWeekApr = usePastWeekApr()
  const { boostPoolData } = useVvsBoostPool()
  const rate = useXvvsRate()
  const { poolWeight, totalSupply: vaultTotalSupply, poolInfo } = boostPoolData

  const ratios = poolInfo.map((x) => {
    const mulitiplier = boostPools.find((pool) => pool.pid === x.poolId)?.multiplier || 0
    return x.stakes.times(mulitiplier).div(vaultTotalSupply)
  })
  const vvsPerYear = useVvsPerBlock((s) => s.value.vvsPerYear)

  const totalXVvsRewardPerYear = poolWeight.times(vvsPerYear).div(rate ? rate.toSignificant(18) : BIG_ONE)
  const rewards = ratios.map((x) => x.times(totalXVvsRewardPerYear))

  const apr = poolInfo
    .map((x, i) => ({
      poolId: x.poolId,
      apr: rewards[i].div(getBalanceAmount(x.stakes, tokens.xvvs.decimals)).times(100).plus(pastWeekApr.toString()),
    }))
    .map((x) => ({ poolId: x.poolId, apr: x.apr.isNaN() ? '0' : x.apr.toFixed(2) }))

  return apr
}
